import { OTA_VehType } from "./ota_vehtype.model";
import { OTA_VehMakeModel } from "./ota_vehmakemodel.model";

export class OTA_VehPref {
    public code: string;
    public codeContext: string;
    public vehType = new OTA_VehType();
    public vehMakeModel = new OTA_VehMakeModel();
}
